/* Zorsay mirror-field: volumetric light through scattered shisha diamonds,
   with a fabric photo showing through the mask windows. One scene per
   [data-ralli-field] element; photo URL comes from data-photo. */
(function () {
  var VERT = "attribute vec2 position;void main(){gl_Position=vec4(position,0.0,1.0);}";

  var FRAG = [
    "precision highp float;",
    "uniform vec2 u_resolution;uniform float u_pxaspect;uniform vec2 u_mouse;uniform float u_time;",
    "uniform sampler2D u_noise;uniform sampler2D u_mask;uniform sampler2D u_photo;",
    "uniform float u_photomix;uniform vec2 u_photosize;",
    "uniform vec3 u_lightcol;uniform vec3 u_falloffcol;uniform vec3 u_bg;",
    "uniform float u_exposure;uniform float u_maskscale;uniform float u_emissive;",
    "const float decay=0.97;const float density=0.98;const float weight=0.2;const int SAMPLES=12;",
    "const float lightStrength=1.5;const float falloff=0.3;",
    "float random2d(vec2 uv){uv/=256.0;vec4 t=texture2D(u_noise,uv);return mix(t.x,t.y,t.a);}",
    "float noise3(vec2 st){vec3 x=vec3(st,1.0);vec3 p=floor(x);vec3 f=fract(x);f=f*f*(3.0-2.0*f);",
    "vec2 uv=(p.xy+vec2(37.0,17.0)*p.z)+f.xy;vec2 rg=texture2D(u_noise,(uv+0.5)/256.0).yx-0.5;return mix(rg.x,rg.y,f.z);}",
    "float fbm1(in vec2 st){float v=0.0;float a=0.5;vec2 shift=vec2(100.0);",
    "mat2 rot=mat2(cos(0.5),sin(0.5),-sin(0.5),cos(0.5));",
    "v+=a*noise3(st);st=rot*st*2.0+shift;a*=0.4;return v+0.4;}",
    "float pattern(vec2 uv,float time,inout vec2 q,inout vec2 r){",
    "q=vec2(fbm1(uv),fbm1(uv+vec2(5.2,1.3)));",
    "r=vec2(fbm1(uv+4.0*q+vec2(1.7-time/2.0,9.2)),fbm1(uv+4.0*q+vec2(8.3-time/2.0,2.8)));",
    "return fbm1(uv+4.0*r);}",
    "vec2 maskUV(vec2 uv){vec2 res=u_resolution/u_pxaspect;float aspect=res.x/res.y;",
    "float maxW=u_maskscale;float maxH=u_maskscale;",
    "if(res.x<768.0){maxW*=1.3;maxH*=1.3;}",
    "float scale=min(maxW,maxH*aspect);uv=uv*scale+0.5;return clamp(uv,0.0,1.0);}",
    "vec4 maskTexel(vec2 uv){return texture2D(u_mask,maskUV(uv));}",
    "float shapes(vec2 uv){return maskTexel(uv).x;}",
    "float occlusion(vec2 uv,vec2 lightpos,float objects){",
    "return (1.0-smoothstep(0.0,lightStrength*2.0,length(lightpos-uv)*0.5))*(1.0-objects);}",
    "void main(){",
    "vec2 uvC=(gl_FragCoord.xy-0.5*u_resolution.xy)/min(u_resolution.y,u_resolution.x);",
    "float scale=4.0;vec2 uv=uvC*scale;vec2 _uv=uv;vec2 lightpos=u_mouse*scale;",
    "float currentExposure=u_exposure+(sin(u_time)*0.5+1.0)*0.05;",
    "float obj=shapes(uv);float map=occlusion(uv,lightpos,obj);",
    "vec2 q=vec2(0.0);vec2 r=vec2(0.0);float _pattern=pattern(_uv*3.0,u_time,q,r)/2.0;",
    "vec2 dtc=(_uv-lightpos)*(1.0/float(SAMPLES)*density);float illumination_decay=1.0;",
    "for(int i=0;i<SAMPLES;i++){_uv-=dtc;uv+=_pattern/16.0;",
    "float movement=u_time*20.0*float(i+1);",
    "float dither=random2d(uv*512.0+mod(vec2(movement*sin(u_time*0.5),-movement),1000.0))*2.0;",
    "float stepped_map=occlusion(uv,lightpos,shapes(_uv+dtc*dither));",
    "stepped_map*=illumination_decay*weight;illumination_decay*=decay;map+=stepped_map;}",
    "if(u_emissive>0.0){vec4 mt=maskTexel(uvC*scale);",
    "float win=smoothstep(0.6,1.0,1.0-mt.x)*(1.0-mt.y);",
    "float d=length(lightpos-uvC*scale);float cell=random2d(floor(uvC*64.0)*4.3);",
    "float et=u_time/7.0+cell*13.0;",
    "float gate=step(random2d(vec2(floor(et)*0.37,cell*7.9)),0.333);",
    "float flash=gate*pow(sin(3.14159*fract(et)),8.0);",
    "float tw=0.75+0.25*sin(u_time*0.9+cell*43.0);",
    "float prox=pow(clamp(1.0-d*0.22,0.0,1.0),2.0);",
    "map+=win*(prox*tw+flash*(0.5+prox)*0.8)*u_emissive;",
    "float et2=u_time/5.0+cell*29.0;",
    "float gate2=step(random2d(vec2(floor(et2)*0.73,cell*3.1)),0.15);",
    "float glint=gate2*pow(sin(3.14159*fract(et2)),24.0);",
    "map+=win*glint*(3.0+prox*1.5)*u_emissive;}",
    "float l=length(lightpos-uvC*scale);",
    "vec3 lc=mix(u_lightcol,u_falloffcol,l*falloff);",
    "vec3 col=u_bg+map*currentExposure*lc;",
    "if(u_photomix>0.0){vec2 muv=maskUV(uvC*scale);",
    "float win=smoothstep(0.35,0.75,1.0-texture2D(u_mask,muv).x);",
    "vec2 puv=muv-0.5;float pa=u_photosize.x/max(u_photosize.y,1.0);",
    "if(pa>1.0){puv.x/=pa;}else{puv.y*=pa;}puv+=0.5;",
    "vec3 photo=texture2D(u_photo,puv).rgb;",
    "float lit=clamp(0.34+map*currentExposure*2.2,0.0,1.3);",
    "vec3 photoCol=photo*lit*vec3(1.05,0.96,0.88);",
    "/* mirror diamonds: cool silver that answers the light source, */",
    "/* soft shimmer, no oversized flares */",
    "float mtype=step(0.5,texture2D(u_mask,muv).b);",
    "float md=length(lightpos-uvC*scale);",
    "float shine=0.28+0.72*pow(clamp(1.0-md*0.18,0.0,1.0),2.0);",
    "float shimmer=0.85+0.3*noise3(uvC*46.0+vec2(u_time*0.25,u_time*0.18));",
    "vec3 mirrorCol=vec3(0.72,0.8,0.84)*shine*shimmer+lc*currentExposure*map*0.45;",
    "mirrorCol=min(mirrorCol,vec3(1.15));",
    "col=mix(col,mix(photoCol,mirrorCol,mtype),win*u_photomix);}",
    "col+=(random2d(gl_FragCoord.xy*0.5+mod(u_time*60.0,256.0))-0.5)*0.035;",
    "col*=1.0-0.32*smoothstep(0.45,1.5,length(uvC));",
    "gl_FragColor=vec4(col,1.0);}"
  ].join("\n");

  function makeNoiseTexture(gl) {
    var size = 256;
    var data = new Uint8Array(size * size * 4);
    for (var i = 0; i < data.length; i++) data[i] = (Math.random() * 256) | 0;
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, size, size, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    return tex;
  }

  function drawMirrors(ctx, S) {
    var s = 987654321;
    function rnd() { s ^= s << 13; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; }
    var cx = S / 2, cy = S * 0.44, N = 78;
    for (var i = 0; i < N; i++) {
      var t = i / N;
      var rad = S * 0.44 * Math.sqrt(t);
      var a = i * 2.39996 + rnd() * 0.35;
      var x = cx + Math.cos(a) * rad + (rnd() - 0.5) * S * 0.04;
      var y = cy + Math.sin(a) * rad + (rnd() - 0.5) * S * 0.04;
      var m = S * 0.055;
      x = Math.min(Math.max(x, m), S - m);
      y = Math.min(Math.max(y, m), S - m);
      var r = S * (0.014 + 0.034 * (1 - t) * (0.4 + rnd() * 0.6));
      /* half the diamonds are true mirrors (blue-channel flag), the
         other half stay windows into the fabric photo */
      var isMirror = rnd() < 0.5;
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(Math.PI / 4 + (rnd() - 0.5) * 0.5);
      ctx.fillStyle = isMirror ? "#0000ff" : "#000000";
      ctx.fillRect(-r, -r, r * 2, r * 2);
      ctx.restore();
    }
  }

  function makeMaskTexture(gl) {
    var S = 1024;
    var cv = document.createElement("canvas");
    cv.width = cv.height = S;
    var ctx = cv.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, S, S);
    ctx.fillStyle = "#000";
    drawMirrors(ctx, S);
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, cv);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    return tex;
  }

  var IDLE_AFTER = 5;
  var COARSE = matchMedia("(pointer: coarse)").matches;
  var DPR_CAP = COARSE ? 1.25 : 1.75;

  function createScene(section) {
    var canvas = section.querySelector("canvas");
    var gl = canvas.getContext("webgl", { antialias: false, alpha: false });
    if (!gl) return null;

    var prog = gl.createProgram();
    var pairs = [[gl.VERTEX_SHADER, VERT], [gl.FRAGMENT_SHADER, FRAG]];
    for (var i = 0; i < 2; i++) {
      var sh = gl.createShader(pairs[i][0]);
      gl.shaderSource(sh, pairs[i][1]);
      gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { console.error(gl.getShaderInfoLog(sh)); return null; }
      gl.attachShader(prog, sh);
    }
    gl.linkProgram(prog);
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, "position");
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var U = {};
    ["u_resolution", "u_pxaspect", "u_mouse", "u_time", "u_noise", "u_mask", "u_photo",
     "u_photomix", "u_photosize", "u_lightcol", "u_falloffcol", "u_bg", "u_exposure",
     "u_maskscale", "u_emissive"].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });

    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, makeNoiseTexture(gl));
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, makeMaskTexture(gl));
    gl.uniform1i(U.u_noise, 0);
    gl.uniform1i(U.u_mask, 1);
    gl.uniform1f(U.u_photomix, 0);
    gl.uniform3f(U.u_lightcol, 0.93, 1.0, 0.97);
    gl.uniform3f(U.u_falloffcol, 1.4, 2.0, 1.7);
    gl.uniform3f(U.u_bg, 0.027, 0.035, 0.039);
    gl.uniform1f(U.u_exposure, 0.22);
    gl.uniform1f(U.u_maskscale, 0.52);
    gl.uniform1f(U.u_emissive, 1.1);

    var scene = {
      section: section, canvas: canvas, gl: gl, U: U, prog: prog,
      visible: false, lastPoke: -Infinity,
      home: [0, 0.03],
      mouse: { x: 0, y: 0.03 }, target: { x: 0, y: 0.03 }
    };

    var photoSrc = section.getAttribute("data-photo");
    if (photoSrc) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        var tex = gl.createTexture();
        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, tex);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.useProgram(prog);
        gl.uniform1i(U.u_photo, 2);
        gl.uniform2f(U.u_photosize, img.naturalWidth, img.naturalHeight);
        gl.uniform1f(U.u_photomix, 0.9);
      };
      img.src = photoSrc;
    }

    scene.resize = function () {
      var dpr = Math.min(window.devicePixelRatio || 1, DPR_CAP);
      var w = (canvas.clientWidth * dpr) | 0;
      var h = (canvas.clientHeight * dpr) | 0;
      if (w > 0 && h > 0 && (canvas.width !== w || canvas.height !== h)) {
        canvas.width = w; canvas.height = h;
      }
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(U.u_resolution, canvas.width, canvas.height);
      gl.uniform1f(U.u_pxaspect, dpr);
    };

    scene.pointer = function (clientX, clientY, t) {
      var r = canvas.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) return;
      var m = Math.min(r.width, r.height);
      scene.target.x = ((clientX - r.left) / r.width - 0.5) * (r.width / m);
      scene.target.y = (0.5 - (clientY - r.top) / r.height) * (r.height / m);
      scene.lastPoke = t;
    };

    scene.render = function (t) {
      if (t - scene.lastPoke > IDLE_AFTER) {
        scene.target.x = scene.home[0];
        scene.target.y = scene.home[1];
      }
      scene.mouse.x += (scene.target.x - scene.mouse.x) * 0.08;
      scene.mouse.y += (scene.target.y - scene.mouse.y) * 0.08;
      var wx = 0.018 * Math.sin(t * 0.9) + 0.012 * Math.sin(t * 1.53 + 1.7) + 0.007 * Math.sin(t * 2.71 + 0.4);
      var wy = 0.014 * Math.sin(t * 1.13 + 0.9) + 0.009 * Math.sin(t * 1.97 + 2.1);
      gl.uniform2f(U.u_mouse, scene.mouse.x + wx, scene.mouse.y + wy);
      gl.uniform1f(U.u_time, t);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    };

    scene.resize();
    return scene;
  }

  function boot() {
    var scenes = [];
    document.querySelectorAll("[data-ralli-field]").forEach(function (el) {
      var sc = createScene(el);
      if (sc) scenes.push(sc);
      else el.classList.add("nogl");
    });
    if (!scenes.length) return;

    var startT = performance.now();
    function clock() { return (performance.now() - startT) / 1000; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var sc = scenes.find(function (s) { return s.section === e.target; });
        if (sc) sc.visible = e.isIntersecting;
      });
    }, { threshold: 0.15 });
    scenes.forEach(function (s) { io.observe(s.section); });

    function poke(x, y) {
      var t = clock();
      scenes.forEach(function (s) { if (s.visible) s.pointer(x, y, t); });
    }
    window.addEventListener("pointermove", function (e) { poke(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener("pointerdown", function (e) { poke(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener("touchmove", function (e) {
      var t = e.touches[0];
      if (t) poke(t.clientX, t.clientY);
    }, { passive: true });
    window.addEventListener("resize", function () { scenes.forEach(function (s) { s.resize(); }); });

    var tick = 0;
    (function frame() {
      tick++;
      var t = clock();
      scenes.forEach(function (s) {
        if (!s.visible) return;
        var resting = t - s.lastPoke > IDLE_AFTER &&
          Math.abs(s.mouse.x - s.target.x) < 0.01 &&
          Math.abs(s.mouse.y - s.target.y) < 0.01;
        if (resting && tick % 2 === 0) return;
        s.render(t);
      });
      requestAnimationFrame(frame);
    })();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
